import React, { useState } from "react";
import Botton from "../../../../utils/components/Button/Button";
import InputSearch from "../../../../utils/components/InputSearch/InputSearch";
import CardList from "../../../../utils/components/CardList/CardList";
import { useHistory } from "react-router-dom";
import style from "./Warehouses.module.css";
import { Translate } from "../../../../language";
import useModal from "../../../../utils/hooks/useModal";
import DeleteModal from "../Warehouses/DeleteModal";
import { WineryIcon } from "../../../../assets/icons";
import cardStyle from "./CardListWarehouses.module.css"
const Warehouses = ({
    setWareHouse,
    wareHouse,
    searchAction = () => { },
    listWarehouses = [],
    title,
}) => {
    const history = useHistory()
    const [refDelete, isShowDelete, setIsShowDelete] = useModal(false)

    return (
        <div className={style.content_create}>
            <div className={style.content_principal}>
                <div style={{ marginLeft: 0 }} className="title-register">
                    {Translate("wareHouses", "es")}
                </div>
                <Botton onClick={() => history.push('/Admin/Inventory/CreateWareHouse')} text={Translate("create", "es")} styles={{ width: '70%', margin: '4vw auto 2vw auto' }} />
                <InputSearch isDrowMenu={false} searchData={(value) => searchAction(value)} placeholder={Translate("searchIn", "es") + Translate("wareHouses", "es").toLowerCase()} classNameContent="white" />
                <DeleteModal
                    closeModal={setIsShowDelete}
                    displayModal={isShowDelete}
                    wareHouse={wareHouse}
                />
            </div>
            <div className={style.content_list}>
                {listWarehouses.map((warehouse, index) =>
                    <CardList
                        picture={warehouse.profileId.picture?.url.small}
                        style={cardStyle}
                        key={index}
                        options={[
                            // {
                            //     text: Translate('deleteWareHouse', 'es'),
                            //     onClick: (e) => {
                            //         e.stopPropagation();
                            //         setWareHouse(warehouse)
                            //         setIsShowDelete(true)
                            //         //dispatch(deleteWareHouse(element._id))
                            //     }
                            // },
                            {
                                text: Translate("edit", "es"),
                                onClick: (e) => {
                                    e.stopPropagation();
                                    history.push('/Admin/Inventory/UpdateWareHouse/' + warehouse._id)
                                }
                            }
                        ]}
                        
                         text={warehouse.name} />
                )}
            </div>
        </div>
    );
};

export default Warehouses;
